//
// ReportPrivateData.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";

var ReportPrivateData = createModule("transport::ReportPrivateData", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        visualContainers: [7],
        pages: [7],
        dataSourcesUsePrivateData: [7],
        dataSourcesHavePrivateData: [7],
        reportUsesPrivateData: 2,
        visualElements: [7],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportPrivateData;
